import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import soundImg from "../../assets/soundImg.svg";
import arrowImg from "../../assets/arrowImg.svg";
import cardImg2 from "../../assets/cardImg2.svg";
import CustomButton from "./CustomButton";

const sliderItems = [
  {
    id: 1,
    text: "Connect with verified local guides via live-streamed experiences",
    image: soundImg,
  },
  {
    id: 2,
    text: "Explore cities in real-time with personalized recommendations.",
    image: arrowImg,
  },
  {
    id: 3,
    text: "Hassle-free guide booking, direct from your phone.",
    image: cardImg2,
  },
];

const CustomSlider = ({ isDots = true, isIntroModal = false, onClose }) => {
  const sliderRef = useRef(null);
  const [step, setStep] = useState(1);

  const settings = {
    dots: isDots,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "8px",
    beforeChange: (_, next) => setStep(next + 1),
  };

  const handleNextStep = () => {
      onClose();
    // if (step < sliderItems.length) {
    //   sliderRef.current?.slickNext();
    // } else {
    //   onClose();
    // }
  };

  return (
    <Box
      sx={{
        height: "auto",
        mt: 2,
        mx: "auto",
        "& .slick-slider": {
          width: "calc(100vw - 32px) !important",
          "@media (min-width: 600px)": {
            width: "calc(100vw - 80px) !important",
            maxWidth: isIntroModal ? "360px !important" : "968px !important",
            // maxWidth: "968px !important",
          },
        },
        "& .slick-list": {
          display: "flex !important",
          width: "calc(100vw - 24px) !important",
          "@media (min-width: 600px)": {
            width: "calc(100vw - 72px) !important",
            maxWidth: isIntroModal ? "360px !important" : "968px !important",
            // maxWidth: "968px !important",
          },
        },
        "& .slick-track": {
          display: "flex !important",
        },
        "& .slick-slide": {
          display: "flex !important",
          justifyContent: "center",
          alignItems: "stretch",
        },
        "& .slick-slide + .slick-slide > div": {
          width: "calc(100% + 16px) !important",
        },
        "& .slick-slide > div": {
          width: "calc(100% + 16px) !important",
        },
        "& .slick-next": {
          display: "none !important",
        },
        "& .slick-prev": {
          display: "none !important",
        },
        "& .slick-dots li": {
          margin: "0 !important",
        },
      }}
    >
      <Slider ref={sliderRef} {...settings}>
        {sliderItems.map((item) => (
          <Box
            key={item.id}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
              width: "100% !important",
            }}
          >
            <Box
              sx={{
                p: 3,
                bgcolor: "black",
                borderRadius: 2,
                width: "calc(100% - 8px) !important",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box display={"flex"} alignItems={"center"} gap={1}>
                <Box
                  component={"img"}
                  src={item.image}
                  alt="image"
                  width={"40px"}
                  height={"auto"}
                />
                <Typography color="white">{item.text}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>
      {isIntroModal && (
        <Box
          flex={1}
          mt={'80px'}
        >
          <CustomButton 
            onClick={handleNextStep}
            backgroundColor="#1E1E1F"
            border="1px solid #1E1E1F"
          >
            {step < sliderItems.length ? "Continue" : "Get started"}
          </CustomButton>
        </Box>
      )}
    </Box>
  );
};

export default CustomSlider;
